import { GridFilterItem, GridSortModel } from "@mui/x-data-grid-pro"
import { axios } from "../../api"
import { AxiosResponse } from "axios"

const FilterApi = async(filterItem:GridFilterItem[],function_name:string = "") =>{

    let filterPayload = {
        function:function_name,
        json_string:JSON.stringify(filterItem),
        description:"admin"
    }
    console.log(filterPayload,"filterPayload")
    await axios.post("/v6/filters",filterPayload)
}

export const FilterGetApi = async (function_name: string) => {
    const resp: AxiosResponse = await axios.get(
      `/v6/filters/${function_name}`,
      // Never cached: a cached read writes a "loading" entry that a page left
      // mid-request keeps for good (Synergy QA 2026-10-21, defect 3). The remove
      // clears an entry an older build left under this id.
      { cache: false }
    );
    axios.storage.remove(`get-filter-${function_name}`);
    return resp.data;
  }

export const FilterDelete = async(function_nam:string) =>{
    await axios.delete(`/v6/filters/${function_nam}`)
}


export const UserDisplayPreference = async(userPreference:Object,function_name:string = "") =>{

    let filterPayload = {
        function:function_name,
        json_string:JSON.stringify(userPreference),
        description:"admin"
    }
    console.log(filterPayload,"filterPayload")
    await axios.post("/v6/filters/display",filterPayload)
}


export const UserDisplayPreferenceGet = async(function_name: string) => {
    const resp: AxiosResponse = await axios.get(
      `/v6/filters/display/${function_name}`,
      // Never cached: a cached read writes a "loading" entry that a page left
      // mid-request keeps for good (Synergy QA 2026-10-21, defect 3). The remove
      // clears an entry an older build left under this id.
      { cache: false }
    );
    axios.storage.remove(`get-display-${function_name}`);
    return resp.data;
  }


export const UserSortPreference = async(sortModel:GridSortModel,function_name:string = "") =>{

    let sortPayload = {
        function:function_name,
        json_string:JSON.stringify(sortModel),
        description:"admin"
    }
    console.log(sortPayload,"filterPayload")
    await axios.post("/v6/sort",sortPayload)
}


export const UserSortPreferenceGet = async(function_name: string) => {
    const resp: AxiosResponse = await axios.get(
      `/v6/sort/${function_name}`,
      // Never cached: a cached read writes a "loading" entry that a page left
      // mid-request keeps for good (Synergy QA 2026-10-21, defect 3). The remove
      // clears an entry an older build left under this id.
      { cache: false }
    );
    axios.storage.remove(`get-sort-${function_name}`);
    return resp.data;
  }

export default FilterApi